import { GET_EVENTS, SELECT_EVENT, SELECT_EVENTCLASS, SELECT_TRACK, DESELECT_EVENT, DESELECT_EVENTCLASS
    , DESELECT_TRACK, NEXT_EVENTCLASS, PREV_EVENTCLASS, SELECT_COMPETITOR, DESELECT_COMPETITOR, EVENT_UPDATED
    , NEXT_SELECTOR, PREV_SELECTOR, SELECT_ITEM, GOT_TIMESTAMP} from './types';
import {SERVER_URL} from '../config'

export const getEvents = () => dispatch => {
    fetch(`${SERVER_URL}/api/events`, {  mode: 'cors', method: 'POST',
    headers: {'Access-Control-Allow-Origin':'*', 'Content-Type': 'application/json'}})
    .then(r => r.json())
//    .then(json => dispatch( { type: GOT_TIMESTAMP, payload: json }))
    .then(json => dispatch ( { type: GET_EVENTS, payload: {events: json} }))
    .catch(error => console.error('Error retrieving events: ' + error));
    
}

export const getLastTimeStamps = () => dispatch => {
    fetch(`${SERVER_URL}/api/lastTimestamps`, {  mode: 'cors', method: 'POST',
    headers: {'Access-Control-Allow-Origin':'*', 'Content-Type': 'application/json'}})
    .then(r => r.json())
    .then(json => dispatch( { type: GOT_TIMESTAMP, payload: json }))
    .catch(error => console.error('Error retrieving vehicles: ' + error));
}

export const selectEvent = (id) => dispatch => {
    fetch(`${SERVER_URL}/api/event/${id}`, {  mode: 'cors', method: 'POST',
    headers: {'Access-Control-Allow-Origin':'*', 'Content-Type': 'application/json'}})
    .then(r => r.json())
    .then(json => dispatch( { type: SELECT_EVENT, payload: {event:json} }))
    .catch(error => console.error('Error retrieving vehicles: ' + error));
}

export const selectEventClass = (eventId, id) => dispatch => {
    dispatch( { type: SELECT_EVENTCLASS, payload: id })
}

export const prevSelector = (type) => dispatch => {
    dispatch( { type: PREV_SELECTOR, payload: {type:type} })
}
export const nextSelector = (type) => dispatch => {
    dispatch( { type: NEXT_SELECTOR, payload: {type:type} })
}
export const selectItem = (type, id) => dispatch => {
    dispatch( { type: SELECT_ITEM, payload: {type:type, id:id} })
}

export const selectCompetitor = (id, eventId) => dispatch => {
    fetch(`${SERVER_URL}/api/competitor.json?id=${id}&eventId=${eventId}`, {  mode: 'cors', method: 'POST',
    headers: {'Access-Control-Allow-Origin':'*', 'Content-Type': 'application/json'}})
    .then(r => r.json())
    .then(json => dispatch( { type: SELECT_COMPETITOR, payload: { competitor:json} }))
    .catch(error => console.error('Error retrieving vehicles: ' + error));
}

export const selectTrack = (id, eventId) => dispatch => {
    fetch(`${SERVER_URL}/api/track.json?id=${id}&eventId=${eventId}`, {  mode: 'cors', method: 'POST',
    headers: {'Access-Control-Allow-Origin':'*', 'Content-Type': 'application/json'}})
    .then(r => r.json())
    .then(json => dispatch( { type: SELECT_TRACK, payload: { track:json} }))
    .catch(error => console.error('Error retrieving vehicles: ' + error));
}

export const updateEvent = (event) => dispatch => {
    fetch(`${SERVER_URL}/api/update.json?id=${event.id}`, {  mode: 'cors', method: 'POST', body: JSON.stringify({type:'event', event:event}),
    headers: {'Access-Control-Allow-Origin':'*', 'Content-Type': 'application/json'}})
    .then(r => r.json())
    .then(json => dispatch( { type: EVENT_UPDATED, payload: { event:json} }))
    .catch(error => console.error('Error retrieving vehicles: ' + error));
}

export const deselectEvent = () => {
    return {type: DESELECT_EVENT}
}

export const deselectEventClass = () => {
    return {type: DESELECT_EVENTCLASS}
}

export const deselectCompetitor = () => {
    return {type: DESELECT_COMPETITOR}
}

export const nextEventClass = () => {
    return {type: NEXT_EVENTCLASS}
}
export const prevEventClass = () => {
    return {type: PREV_EVENTCLASS}
}

export const deselectTrack = () => {
    return {type: DESELECT_TRACK}
}